<template>
   <div class="cart_service_wraps">
    <div class="container-fluid container-app sticky_height">
       <span @click="backToService_cart_comp()" class="backBtn"><i class='bx bxs-chevrons-left bx-tada' ></i>Back</span>
            <VueSkeletonLoader
        v-show="skelton_big"
        class="rects big_loader"
        type="rect"
        :width="290"
        :height="20"
      />
        <div class="grid_service Filter_wrappp">
            <h2
              class="title_suggesion"
              v-show="length_sugg > 0"
            >
              We suggest you some services
            </h2>
            <div class="row">
              <div
               :class="[
                  `col-xl-9 col-lg-8 col-12`
                ]"
              >
                <div class="content_service_TAB">
                  <div class="content_single_service">
                    <div class="row">
                      <!-- Box Service  -->
                      <template v-if="length_sugg > 0">
                        <template v-for="suggesion in get_suggestion_service_in_cart">
                          <template v-for="sugg in suggesion.suggestions">
                            <div
                              :class="[`col-xl-4 col-lg-6 col-md-6 col-12 mb-md-3 mb-4`]"
                              :key="sugg.id"
                            >
                              <span>
                                <!--   -->
                               <!-- your sugg list =  {{fill_suggestion_check_list}} -->
                               <!-- your data is =>{{ sugg.service.id}} + {{suggesion.id}} -->
                                <vs-checkbox
                                  success
                                  @change.native="checkboxSuggestion(suggesion.id , sugg.service.id , $event)"
                                  :val="sugg.service.id"
                                  v-model="fill_suggestion_check_list"
                                  :key="sugg.service.id"
                                >
                           <Tilt :options="option" class="tiltClass">
                                <div class="card">
                            <img v-if="sugg.service.image" :src="sugg.service.image.url">
                            <div class="info">
                            <h1>{{sugg.service.title}}</h1>
                            <p> <span class="fra_p">Fra </span> <span class="pricez">{{sugg.service.price.total.toFixed(0)}}
                                    <span class="curruncy">,-</span>
                                  </span></p>
                            </div>
                            </div>
                              </Tilt>
                                </vs-checkbox>
                              </span>
                            </div>
                          </template>
                        </template>
                      </template>
                      <template v-else>
                        <div class="noService_wrap col-12">
                          <img src="~@/assets/noservice.svg" alt="" />
                          <p>There are no suggested services</p>
                        </div>
                      </template>
                      <!-- end Box Service  -->
                    </div>
                  </div>
                </div>
              </div>
         <!-- invoice -->
           <div
                class="col-xl-3 col-lg-4 col-12 mb-lg-0 mb-4"
              >
                <div class="container_invoice_wrapp zig-zag zig-zag-bottom">
                  <div class="receipt_box">
                    <div class="body">
                      <div class="cart">
                        <div class="content">
                          <ul class="cart_list">
                            <li class="cart_item">
                              <span class="index">No</span>
                              <span class="name">Service Name</span>
                              <span class="price">Pris</span>
                            </li>
                            <li
                              class="cart_item"
                              v-for="(all_service , index) in get_all_cart_data.all_services"
                              :key="all_service.id"
                            >
                            <!-- {{all_service}} -->
                                  <span class="flex_key">
                                  <span class="index">{{ index + 1 }}</span>
                                  <span class="name">{{
                                    all_service.service_name
                                  }}</span>
                                  <span
                                    class="price"
                                    >{{ all_service.price }},-</span
                                  >
                                </span>
                            </li>
                          </ul>
                          <div class="total">
                            <span>total</span>
                            <span class="total_price"
                              >{{total_local.toFixed(0)}},-</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    </div>
  
  
    <div class="save_order_div">
      <a
            class="save_order"
            @click="go_to_calender_comp()"
            ><i class="bx bx-calendar bx-tada mr-2"></i> Bestill Now
          </a>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import VueSkeletonLoader from "skeleton-loader-vue";
import Tilt from 'vanilla-tilt-vue'
import $ from 'jquery';
export default {
  name: "SuggestionCartApp",
   props:['car_number_pass'],
  data() {
    return {
      skelton_big: false,
         skelton_load:false,
         matricule_is_selected:'',
         service_checkbox:[], //coud delete
         fill_suggestion_check_list:[],
         length_sugg:0,
         total_local:0,
          option:{
          glare: true,
          "max-glare": 0.5,
          scale: 1.1,
         }
    };
  },
  components: { VueSkeletonLoader , Tilt },
  computed:{
    ...mapGetters({
     get_suggestion_service_in_cart:'get_suggestion_service_in_cart',
     get_add_sugg_servuce_res:'get_add_sugg_servuce_res',
     get_delete_main_service_res:'get_delete_main_service_res',
     get_all_cart_data:'get_all_cart_data',
    })
  },
  methods: {
    ...mapActions({
      suggestion_cart_api:'suggestion_cart_api',
      add_suggesion_service_cart_api:'add_suggesion_service_cart_api',
      delete_suggesion_service_cart_api:'delete_suggesion_service_cart_api',
       all_cart_data_api:'all_cart_data_api'
    }),
    checkboxSuggestion(master_id , sugg_id , event){
       let suggestion_cart = {
          'service_id':sugg_id,
          'matricule':this.matricule_is_selected,
          "is_suggested": true,
          'service_master_id':master_id
        }
        if( event.target.checked == true){
        console.log(suggestion_cart , 'suggstion from app comp');
        this.add_suggesion_service_cart_api(suggestion_cart).then(()=>{
         this.all_cart_data_api(this.matricule_is_selected).then(()=>{
           this.total_local = 0;
          this.calc_total_func();
         });
        });
        console.log('send add cart Api')
      }else{
      //delete sugg from cart
        this.delete_suggesion_service_cart_api(suggestion_cart).then(()=>{
         this.all_cart_data_api(this.matricule_is_selected,).then(()=>{
           this.total_local = 0;
          this.calc_total_func();
         });
        })
      }
    },
    calc_total_func(){
       // foreach to get total 
       console.log('call total');
        this.get_all_cart_data.all_services.forEach((price_serv)=>{
          console.log(price_serv , '=> price serv');
          this.total_local = this.total_local + price_serv.price;
        });
    },
    go_to_calender_comp(){
      $("html, body").animate({ scrollTop: 0 }, "slow");
        let config_next_component={
        'carlist':false,
        'service_cart':false,
        'suggestion_cart':false,
        'calender':true,
        'total_pass':this.total_local
      }
    this.$emit("clicked", config_next_component);
    },
    backToService_cart_comp(){
     let config_prev_component={
        'carlist':false,
        'service_cart':true,
        'suggestion_cart':false,
        'calender':false,
      }
      this.$emit("clicked", config_prev_component);
    },

    // Notifucation
    openNotification(position = null, color) {
      this.$vs.notification({
        color,
        position,
        title: "Sorry",
        text: "An appointment cannot be booked for a date less than today",
      });
    },
  },
  mounted() {
     this.skelton_big = true;
    document.body.classList.add('cart_sugg');
    // set car number from props in the local data components ##
    this.matricule_is_selected =  this.car_number_pass;
    this.suggestion_cart_api(this.matricule_is_selected).then(()=>{
      this.get_suggestion_service_in_cart.forEach((elm)=>{
        if(elm.suggestions.length > 0){
          this.length_sugg = elm.suggestions.length;
          return;
        }
      })
        this.skelton_big = false;
        this.calc_total_func();
         this.get_all_cart_data.suggestions.forEach(element => {
          console.log('element' , element.suggested_service_id);
          this.fill_suggestion_check_list.push(element.suggested_service_id);
         });
    });
  },
   destroyed(){
      document.body.classList.remove('cart_sugg');
    }
};
</script>
<style lang="scss">
.cart_sugg{
  overflow-x: unset ;
}
</style>
<style lang="scss" scoped>
.cart_service_wraps {
  min-height: 100vh;
  padding-top: 0px;
    .backBtn{
    background-color: var(--red_color);
    color: white;
    padding: 4px 40px;
    border-radius: 30px;
    display: inline-block;
    margin-top: 20px;
    margin-bottom: 20px;
    transition: 0.2s ease-in-out;
    i{
      vertical-align: middle;
      padding-right: 4px;
    }
    cursor: pointer;
    &:hover{
      background-color: darken($color: #db0816, $amount: 10%);
    }

  }
}
.box_service{
    width: 100%;
}
.desc_serv{
   overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            min-height: 41px;
}
.noService_wrap {
  text-align: center;
  padding-bottom: 50px;
  padding-top: 40px;
  img {
    height: 320px;
    width: 100%;
    margin-bottom: 20px;
  }
}
.row_pd{
  padding-top: 20px;
}
.sticky_height{
  min-height: 100vh;
}
.save_order_div {
  position: sticky;
  bottom: 50px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
.title_suggesion{
  font-size: 22px;
  font-weight: 500;
   font-family: 'Oswald',sans-serif;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: var(--active_color);
    margin-top: 10px;
    margin-bottom: 0px;
}
</style>

